export default "__VITE_ASSET__C_CI30aU__"